import { useEffect } from 'react';
import { ActionCreatorWithPayload, Dispatch, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import { useForm } from 'react-hook-form';
import { Input } from 'components';
import { GetPatientCasesParams } from 'types';

type Props = {
  search: string | undefined;
  requestParams: GetPatientCasesParams;
  callback: ThunkDispatch<any, undefined, UnknownAction> & Dispatch<UnknownAction>;
  action: ActionCreatorWithPayload<GetPatientCasesParams, 'patients/setPatientPageFilters'>;
};

export const SearchInput = ({ search, requestParams, callback, action }: Props) => {
  const { register, watch, setValue } = useForm();

  const searchValue = watch('searchPatient');

  const requestParamsWithoutPage = { ...requestParams };
  delete requestParamsWithoutPage.page;

  useEffect(() => {
    if (searchValue) {
      const debounceTimer = setTimeout(() => {
        callback(action({ ...requestParamsWithoutPage, search: searchValue }));
      }, 250);
      return () => clearTimeout(debounceTimer);
    }
    if (search && !searchValue) {
      const newRequestParams = { ...requestParamsWithoutPage };
      delete newRequestParams.search;
      callback(action(newRequestParams));
    }
  }, [searchValue]);

  return (
    <Input
      inputName="searchPatient"
      placeholder="Search by patient"
      register={register}
      canContainError={false}
      iconName="Search"
      autoComplete="off"
      setValue={setValue}
      canBeCleared={true}
      currentValue={searchValue}
    />
  );
};
